<template>
  <div>
    <component
      :is="'script'"
      src="https://facecast.net/w/js/iframe.js"
      onload="fc_load_iframe(document.getElementById('s3w2l9'), 'ar_16_9')"
    />
    <iframe
      id="s3w2l9"
      onload="typeof fc_load_iframe === 'function' && fc_load_iframe(this, 'ar_16_9')"
      style="border: none; display: block; height: auto; aspect-ratio: 16 / 9"
      allow="autoplay; fullscreen"
      allowfullscreen
      width="100%"
    />
  </div>
</template>
